<script setup lang="ts">
  /**
   * 404 Not Found View
   */
  import { useRouter } from 'vue-router'

  const router = useRouter()

  function goHome() {
    router.push('/')
  }
</script>

<template>
  <div class="flex min-h-screen items-center justify-center bg-secondary-50 px-4">
    <div class="text-center">
      <h1 class="text-9xl font-bold text-primary-600">404</h1>
      <h2 class="mt-4 text-3xl font-semibold text-secondary-900">Page Not Found</h2>
      <p class="mt-4 text-lg text-secondary-600">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <PButton
        label="Go Home"
        icon="pi pi-home"
        class="mt-8"
        @click="goHome"
      />
    </div>
  </div>
</template>
